import MUIDataTable from "mui-datatables";

import { useTranslation } from "react-i18next";
import { getColumns, getOptions } from "./config";

const List = ({ data }) => {
	const { t } = useTranslation();

	const columns = getColumns(t);
	const options = getOptions(t);

	return (
		<MUIDataTable
			className="mui-data-table blacklist-table"
			data={data}
			columns={columns}
			options={options}
		/>
	);
};

export default List;
